<div loader class="ph-layout ph-loading-effect" [class.loading]="!categoriesAreReady()">
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
  <div class="ph-shape"></div>
</div>

<!-- <pre>
  categoriesAreLoading: {{ categoriesAreLoading() | json }}
  categoriesAreReady: {{ categoriesAreReady() | json }}
</pre> -->

<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
  <mat-nested-tree-node *matTreeNodeDef="let node" [class.selected]="isSelected(node)">
    <div class="item">
      <div class="selector"></div>
      <div class="toggle">
        <button mat-icon-button style="visibility: hidden"></button>
      </div>
      <ng-container *ngTemplateOutlet="CategoryNodeItem; context: { $implicit: node }"></ng-container>
    </div>
  </mat-nested-tree-node>
  <mat-nested-tree-node
    *matTreeNodeDef="let node; when: hasChildren"
    class="has-children"
    [class.open]="isExpanded(node)"
    [class.selected]="isSelected(node)"
    [class.child-selected]="isChildSelected(node)"
  >
    <div class="item" matTreeNodeToggle>
      <div class="selector"></div>
      <div class="toggle">
        <button mat-icon-button [attr.aria-label]="'Toggle ' + node.item" [disabled]="!isExpandable(node)">
          <mat-icon class="mat-icon-rtl-mirror">
            {{ isExpanded(node) ? "expand_more" : "chevron_right" }}
          </mat-icon>
        </button>
      </div>
      <ng-container *ngTemplateOutlet="CategoryNodeItem; context: { $implicit: node }"></ng-container>
    </div>
    @if (isExpanded(node)) {
      <div class="children">
        <ng-container matTreeNodeOutlet></ng-container>
      </div>
    }
  </mat-nested-tree-node>
</mat-tree>

<ng-template #CategoryNodeItem let-node>
  <a class="info" [routerLink]="['/products/browse/search']" [queryParams]="categoryParams(node)" routerLinkActive="active">
    <ideal-image [src]="node.thumbnailUrl"></ideal-image>
    <div class="name">
      {{ node.name }}
    </div>
  </a>
</ng-template>
